<template>
    <div class="funnel_app_item">
        <div class="left">
            <div class="img_wrpr" v-if="attributes.small_image">
                <img :src="'data:image/png;base64,' + attributes.small_image">
            </div>
            <div class="text_content">
                <h3>{{attributes.caption}}
                    <div class="info_btn" @click="open()">
	                    <span>Help</span>
	                    <inline-svg :src="require('@/assets/img/info_icon.svg')"/>
                    </div>
                </h3>
                <p>{{attributes.description || ''}}</p>
            </div>
        </div>
        <label class="switch_checkbox_item">
            <input type="checkbox" :checked="active" @change="$emit('toggleActive')">
            <div class="switch_checkbox"><span></span></div>
        </label>
    </div>
</template>
<script>
export default {
    name: 'content-header',
    props: ['active', 'attributes', 'panel'],
	methods:{
    	open(){
    		window.open(`https://docs.funnelish.com/integrations/${this.attributes.name}`, "_blank")
	    }
	}
}
</script>
